import * as React from 'react'

import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarMenu,
    SidebarMenuItem,
} from '@/shared/components/ui/sidebar'
import CharacterLocationTabbar from './CharacterLocationTabbar'
import { ToggleCard } from '@/components/custom/ToggelCard'
import { useSpEditorProvider } from './editor/SpEditorProvider'

export function SpOptionBar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { updateFeatureEnabled, featuresEnabled } = useSpEditorProvider()

    return (
        <Sidebar
            collapsible="none"
            className="sticky top-0 hidden h-svh border-l lg:flex"
            {...props}
        >
            <SidebarContent className="flex flex-col">
                <CharacterLocationTabbar />
            </SidebarContent>
            <SidebarFooter>
                <SidebarMenu>
                    {false && (
                        <SidebarMenuItem>
                            <ToggleCard
                                id="toggle-ai-suggestion"
                                titleEnabled="AI Suggestions On"
                                titleDisabled="AI Suggestions Off"
                                description="Suggests text as you type."
                                checked={featuresEnabled.aiCompletion}
                                onChange={async (checked) => {
                                    updateFeatureEnabled({ ...featuresEnabled, aiCompletion: checked })
                                }}
                            />
                        </SidebarMenuItem>
                    )}
                    <SidebarMenuItem>
                        <ToggleCard
                            id="toggle-node-toolbar"
                            titleEnabled="Inline Toolbar Shown"
                            titleDisabled="Show Inline Toolbar"
                            description="Floating tools at end of lines."
                            checked={featuresEnabled.nodeToolbar}
                            onChange={(checked) => {
                                updateFeatureEnabled({ ...featuresEnabled, nodeToolbar: checked })
                            }}
                        />
                    </SidebarMenuItem>

                    <SidebarMenuItem>
                        <ToggleCard
                            id="toggle-suggestion-dropdown"
                            titleEnabled="Dropdown Suggestions On"
                            titleDisabled="Show Suggestions Dropdown"
                            description="Shows quick command suggestions."
                            checked={featuresEnabled.suggestionDropdown}
                            onChange={(checked) => {
                                updateFeatureEnabled({ ...featuresEnabled, suggestionDropdown: checked })
                            }}
                        />
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarFooter>
        </Sidebar>
    )
}
